import { toast as sonnerToast } from 'sonner'

export const useToast = () => {
  const showSuccess = (message: string) => {
    sonnerToast.success(message)
  }

  const showError = (message: string) => {
    sonnerToast.error(message)
  }

  const showInfo = (message: string) => {
    sonnerToast.info(message)
  }

  const showWarning = (message: string) => {
    sonnerToast.warning(message)
  }

  const showLoading = (message: string) => {
    return sonnerToast.loading(message)
  }

  const dismiss = (toastId?: string | number) => {
    sonnerToast.dismiss(toastId)
  }

  const toast = (message: string, type?: 'success' | 'error' | 'info' | 'warning') => {
    if (type) {
      sonnerToast[type](message)
    } else {
      sonnerToast(message)
    }
  }

  return {
    showSuccess,
    showError,
    showInfo,
    showWarning,
    showLoading,
    dismiss,
    toast,
    // Aliases for backward compatibility
    success: showSuccess,
    error: showError,
    info: showInfo,
    warning: showWarning,
  }
}
